import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { OperationType, ROUTE_PATH } from 'common/constants/sm-constants';
import { RouteEnvelope, WidgetModel } from 'common/models/utility-models/base-model';
import { AuthenticationService } from 'common/services/core-services/authentication.service';
import { TokenService } from 'common/services/core-services/get-token.service';
import { NavigationService } from 'common/services/core-services/navigation.service';
import { SystemService } from 'common/services/core-services/system.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  role: any = '';
  // bsModalRef: BsModalRef;
  profile: any = {};
  public pushRightClass: string;
  private previousUrl: string = '';

  constructor(
    private authenticationService: AuthenticationService,
    private systemService: SystemService,
    // private modalService: BsModalService,
    // private global: Global,
    private navigationService: NavigationService,
    private tokenService: TokenService,
    private router: Router, 
    private ss: SystemService) { }

  ngOnInit() {
    const tokenDetails = this.tokenService.getDetailsFromToken(localStorage.getItem('token'));
    // console.log(tokenDetails['tokenData'].id)
    this.profile = tokenDetails['tokenData'].id
    this.pushRightClass = 'shrink';
  }

  screen(type) {
    if (type.toLowerCase() === this.role.toLowerCase()) {
      return true
    }
    if (type.toLowerCase() === this.role.toLowerCase()) {
      return true
    }
    if (type.toLowerCase() === this.role.toLowerCase()) {
      return true
    }
    return false;
  }

  isMobile() {
    return ((window.innerWidth <= 800) && (window.innerHeight <= 600));
  }

  logout() {
    this.systemService.logout();
  }



  toggleSidebar() {
    const sideBar: any = document.querySelector('.side-navbar');
    const page: any = document.querySelector('.page');
    if (this.isMobile()) {
      page.classList.toggle('active-sm');
      sideBar.classList.toggle('show-sm');
      page.classList.remove("active")
      sideBar.classList.remove("shrink")

    } else {
      page.classList.toggle('active');
      sideBar.classList.toggle('shrink');
      page.classList.remove("active-sm")
      sideBar.classList.remove("show-sm")


    }

    // sideBar.classList.toggle(this.pushRightClass);
  }

  // navigateToHelpDesk() {
  //   const envelope = new RouteEnvelope();
  //   envelope.type = OperationType.UPDATE;
  //   envelope.transferData = new WidgetModel();
  //   this.ss.navigateByUrl(ROUTE_PATH.help, envelope);
  // } 


  navigateToHelpDesk() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (!event.url.includes('/helpcenter')) {
          this.previousUrl = event.url;
          
          // Store in session storage as backup
          sessionStorage.setItem('previousUrl', event.url);
        }
      }
    });
  
    const envelope = new RouteEnvelope();
    envelope.type = OperationType.UPDATE;
    envelope.transferData = new WidgetModel();
  
    // Using ss.navigateByUrl instead of router.navigate
    this.ss.navigateByUrl(ROUTE_PATH.help, envelope);
  }

  // helpPopup() {
  //   const subject = new Subject<any>();
  //   this.bsModalRef = this.modalService.show(HelpComponent);
  //   this.bsModalRef.content.subject = subject;
  //   subject.asObservable().subscribe((data) => {
  //     this.bsModalRef.hide();
  //   });
  // }
}
